import script from "./CopySlideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CopySlideModal.vue?vue&type=script&setup=true&lang=js"

import "./CopySlideModal.vue?vue&type=style&index=0&id=d04ca124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d04ca124"]])

export default __exports__